import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection';
import LaunchAnnouncement from './components/LaunchAnnouncement/LaunchAnnouncement';
import AboutSection from './components/AboutSection/AboutSection';
import SolutionsSection from './components/SolutionsSection/SolutionsSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection/TestimonialsSection';
import ContactSection from './components/ContactSection/ContactSection';
import Footer from './components/Footer/Footer';
import SEOHead from './components/SEOHead/SEOHead';
import LocalSEO from './components/LocalSEO/LocalSEO';
import { seoConfig, generateOrganizationSchema, generateServiceSchema } from './utils/seoConfig';
import './App.css';
import './accessibility.css';

function App() {
  const organizationSchema = generateOrganizationSchema();
  const serviceSchema = generateServiceSchema();
  
  const combinedStructuredData = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, serviceSchema]
  };

  return (
    <HelmetProvider>
      <div className="App">
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <SEOHead 
          title={null} // Will use default title
          description={seoConfig.defaultDescription}
          keywords={seoConfig.defaultKeywords}
          canonical="/"
          structuredData={combinedStructuredData}
        />
        <LocalSEO />
        <Header />
        <main id="main-content" role="main">
          <HeroSection />
          <LaunchAnnouncement />
          <AboutSection />
          <SolutionsSection />
          <FeaturesSection />
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;